import { PermanentEntry } from '@addins/core/menus';
import { MenuEntry } from '@services/menu/entry.schema';
import { CallcardListFullComponent } from '../../views/callcard-list-full/callcard-list-full.component';

export class FullViewMenuTool extends PermanentEntry {
  public constructor() {
    super(new MenuEntry('cardlist', 'list', CallcardListFullComponent, 1000));
  }
}
